function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 4a4 4 0 014-4h6a4 4 0 014 4v3h5v20a4 4 0 01-4 4H8a4 4 0 01-4-4V7h5V4zm3 3h8V4a1 1 0 00-1-1h-6a1 1 0 00-1 1v3z",
  fill: "url(#delivery_svg__delivery0_linear)",
  fillOpacity: 0.9
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#delivery_svg__filter0_b)",
  fillOpacity: 0.6
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 17v4H4v-4h8z",
  fill: "url(#delivery_svg__delivery1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 19a2 2 0 01-.8 1.6l-8 6A2 2 0 0112 25V13a2 2 0 013.2-1.6l8 6A2 2 0 0124 19z",
  fill: "url(#delivery_svg__delivery2_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "delivery_svg__delivery0_linear",
  x1: 28,
  y1: 19,
  x2: 10.213,
  y2: 8.488,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#42E065"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#53F464"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "delivery_svg__delivery1_linear",
  x1: 24,
  y1: 19,
  x2: 4,
  y2: 19,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9EFFC5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "delivery_svg__delivery2_linear",
  x1: 24,
  y1: 19,
  x2: 4,
  y2: 19,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9EFFC5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("filter", {
  id: "delivery_svg__filter0_b",
  x: -4,
  y: 3,
  width: 36,
  height: 32,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,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";
export { SvgDelivery as ReactComponent };